import { State_update, State_init } from "./State.fs.js";
import { view } from "./View.fs.js";
import { PageHeader } from "../../../../Bfs.Web.Portale/Types.fs.js";
import { ofArray, tail, head, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import { parse } from "../../../fable_modules/fable-library-js.4.19.0/Int32.js";
import { Page } from "./Types.fs.js";
import { int32ToString } from "../../../fable_modules/fable-library-js.4.19.0/Util.js";
import { WebPart$3 } from "../../../../Bfs.Web.Portale/WebPart.fs.js";

export const Part = new WebPart$3(State_init, State_update, view, (_arg_1) => (new PageHeader(1, ["Administration: Auswertungen und Dokumente"])), (_arg_3) => (!isEmpty(_arg_3) ? ((head(_arg_3) === "admin") ? (!isEmpty(tail(_arg_3)) ? ((head(tail(_arg_3)) === "files") ? (!isEmpty(tail(tail(_arg_3))) ? ((head(tail(tail(_arg_3))) === "page") ? (!isEmpty(tail(tail(tail(_arg_3)))) ? (!isEmpty(tail(tail(tail(tail(_arg_3))))) ? (!isEmpty(tail(tail(tail(tail(tail(_arg_3)))))) ? (isEmpty(tail(tail(tail(tail(tail(tail(_arg_3))))))) ? ((head(tail(tail(tail(tail(_arg_3))))) === "page") ? (new Page(parse(head(tail(tail(tail(tail(tail(_arg_3)))))), 511, false, 32), parse(head(tail(tail(_arg_3))), 511, false, 32), head(tail(tail(tail(_arg_3)))))) : undefined) : undefined) : ((head(tail(tail(tail(_arg_3)))) === "page") ? (new Page(parse(head(tail(tail(tail(tail(_arg_3))))), 511, false, 32), parse(head(tail(tail(_arg_3))), 511, false, 32), undefined)) : undefined)) : (new Page(parse(head(tail(tail(tail(_arg_3)))), 511, false, 32), undefined, undefined))) : undefined) : ((head(tail(tail(_arg_3))) === "all") ? (!isEmpty(tail(tail(tail(_arg_3)))) ? ((head(tail(tail(tail(_arg_3)))) === "page") ? (!isEmpty(tail(tail(tail(tail(_arg_3))))) ? (!isEmpty(tail(tail(tail(tail(tail(_arg_3)))))) ? (isEmpty(tail(tail(tail(tail(tail(tail(_arg_3))))))) ? ((head(tail(tail(tail(tail(_arg_3))))) === "page") ? (new Page(parse(head(tail(tail(tail(tail(tail(_arg_3)))))), 511, false, 32), undefined, head(tail(tail(tail(_arg_3)))))) : undefined) : undefined) : (new Page(parse(head(tail(tail(tail(tail(_arg_3))))), 511, false, 32), parse(head(tail(tail(_arg_3))), 511, false, 32), undefined))) : undefined) : (!isEmpty(tail(tail(tail(tail(_arg_3))))) ? ((head(tail(tail(tail(tail(_arg_3))))) === "page") ? (!isEmpty(tail(tail(tail(tail(tail(_arg_3)))))) ? (isEmpty(tail(tail(tail(tail(tail(tail(_arg_3))))))) ? (new Page(parse(head(tail(tail(tail(tail(tail(_arg_3)))))), 511, false, 32), undefined, head(tail(tail(tail(_arg_3)))))) : undefined) : undefined) : undefined) : undefined)) : undefined) : (!isEmpty(tail(tail(tail(_arg_3)))) ? ((head(tail(tail(tail(_arg_3)))) === "page") ? (!isEmpty(tail(tail(tail(tail(_arg_3))))) ? (!isEmpty(tail(tail(tail(tail(tail(_arg_3)))))) ? (isEmpty(tail(tail(tail(tail(tail(tail(_arg_3))))))) ? ((head(tail(tail(tail(tail(_arg_3))))) === "page") ? (new Page(parse(head(tail(tail(tail(tail(tail(_arg_3)))))), 511, false, 32), parse(head(tail(tail(_arg_3))), 511, false, 32), head(tail(tail(tail(_arg_3)))))) : undefined) : undefined) : (new Page(parse(head(tail(tail(tail(tail(_arg_3))))), 511, false, 32), parse(head(tail(tail(_arg_3))), 511, false, 32), undefined))) : undefined) : (!isEmpty(tail(tail(tail(tail(_arg_3))))) ? ((head(tail(tail(tail(tail(_arg_3))))) === "page") ? (!isEmpty(tail(tail(tail(tail(tail(_arg_3)))))) ? (isEmpty(tail(tail(tail(tail(tail(tail(_arg_3))))))) ? (new Page(parse(head(tail(tail(tail(tail(tail(_arg_3)))))), 511, false, 32), parse(head(tail(tail(_arg_3))), 511, false, 32), head(tail(tail(tail(_arg_3)))))) : undefined) : undefined) : undefined) : undefined)) : undefined))) : (new Page(1, undefined, undefined))) : undefined) : undefined) : undefined) : undefined), (_arg_2) => {
    let matchResult, p, kategorie, kdnr, p_1, kdnr_1, p_2, kategorie_1, p_3;
    if (_arg_2.fields[0] === 1) {
        if (_arg_2.fields[1] != null) {
            if (_arg_2.fields[2] == null) {
                matchResult = 3;
                kdnr_1 = _arg_2.fields[1];
                p_2 = _arg_2.fields[0];
            }
            else {
                matchResult = 2;
                kategorie = _arg_2.fields[2];
                kdnr = _arg_2.fields[1];
                p_1 = _arg_2.fields[0];
            }
        }
        else if (_arg_2.fields[2] != null) {
            matchResult = 4;
            kategorie_1 = _arg_2.fields[2];
            p_3 = _arg_2.fields[0];
        }
        else {
            matchResult = 0;
        }
    }
    else if (_arg_2.fields[1] != null) {
        if (_arg_2.fields[2] == null) {
            matchResult = 3;
            kdnr_1 = _arg_2.fields[1];
            p_2 = _arg_2.fields[0];
        }
        else {
            matchResult = 2;
            kategorie = _arg_2.fields[2];
            kdnr = _arg_2.fields[1];
            p_1 = _arg_2.fields[0];
        }
    }
    else if (_arg_2.fields[2] != null) {
        matchResult = 4;
        kategorie_1 = _arg_2.fields[2];
        p_3 = _arg_2.fields[0];
    }
    else {
        matchResult = 1;
        p = _arg_2.fields[0];
    }
    switch (matchResult) {
        case 0:
            return ofArray(["admin", "files"]);
        case 1:
            return ofArray(["admin", "files", "page", int32ToString(p)]);
        case 2:
            return ofArray(["admin", "files", int32ToString(kdnr), kategorie, "page", int32ToString(p_1)]);
        case 3:
            return ofArray(["admin", "files", int32ToString(kdnr_1), "page", int32ToString(p_2)]);
        default:
            return ofArray(["admin", "files", "all", kategorie_1, "page", int32ToString(p_3)]);
    }
}, (_arg) => {
    if (_arg.tag === 13) {
        return _arg.fields[0];
    }
    else {
        return undefined;
    }
});

//# sourceMappingURL=WebPart.fs.js.map
